import React from 'react'

import { SystemAvatar } from '@/components/SystemAvatar'
import { propertyFlagsCopy } from '@/constants/propertyFlag'
import { IPropertyFlag } from '@/types/unlock'

interface PropertyFlagProps {
  propertyFlag: IPropertyFlag
}

export default function PropertyFlag(props: PropertyFlagProps) {
  const { propertyFlag } = props

  const PropertyFlagComponent = ({ children }) => (
    <div className='flex w-full gap-2'>
      <div className='w-max'>
        <SystemAvatar />
      </div>
      <div className='w-10/12'>{children}</div>
    </div>
  )

  return (
    <>
      <PropertyFlagComponent>
        <p
          className='text-[13px] break-all'
          dangerouslySetInnerHTML={{ __html: propertyFlagsCopy[propertyFlag.type] }}
        />
        <div className='flex flex-row items-center py-4 text-[10px] justify-between font-bold'>
          <p>{propertyFlag.read ? 'Read' : 'Unread'}</p>
        </div>
      </PropertyFlagComponent>
      {propertyFlag.answer !== null && (
        <div className='p-2 mt-2'>
          <div className='flex w-full bg-amber-100/60 ml-4 px-1 py-2'>
            <PropertyFlagComponent>
              <p
                className='text-[13px] break-all'
                dangerouslySetInnerHTML={{
                  __html: `${
                    propertyFlag.answer ? 'YES' : 'NO'
                  } - Thank you for replying.  We are updating our records.`,
                }}
              />
            </PropertyFlagComponent>
          </div>
        </div>
      )}

      <hr />
    </>
  )
}
